module.exports = __webpack_public_path__ + "img/pasarvisual-thumbnail.6a4858ee.jpg";